(function () {
  const DEFAULT_STEPS = [
    {
      step: 1,
      title: "Commande en preparation",
      description: "Votre commande est en cours de preparation dans notre entrepot.",
    },
    {
      step: 2,
      title: "Controle qualite",
      description: "Chaque produit est soigneusement inspecte avant expedition.",
    },
    {
      step: 3,
      title: "Remise a notre transporteur",
      description:
        "Votre colis a quitte notre entrepot et est confie a notre transporteur partenaire, qui le remettra ensuite a Colissimo pour la livraison a votre domicile.",
    },
    {
      step: 4,
      title: "En transit",
      description:
        "Votre colis est en route depuis notre entrepot vers votre domicile. La livraison est prevue entre le [DATE_START] et le [DATE_END].",
    },
    {
      step: 5,
      title: "Transfert vers Colissimo",
      description:
        "Votre colis est en cours de transfert vers l'agence Colissimo la plus proche de chez vous. Le suivi sur laposte.fr va s'actualiser tres prochainement.",
    },
    {
      step: 6,
      title: "Pris en charge par Colissimo",
      description:
        "Votre commande est maintenant prise en charge par Colissimo. Vous pouvez suivre votre livraison en temps reel.",
    },
  ];

  const root = document.querySelector("[data-tracking-root]");
  if (!root) return;

  const endpoint = root.getAttribute("data-endpoint") || "/apps/tracking/status";
  const dotiaUrl = root.getAttribute("data-dotia-url") || "/products/dotia";
  const luniaUrl = root.getAttribute("data-lunia-url") || "/products/lunia";
  const dotiaTitle = root.getAttribute("data-dotia-title") || "Dotia";
  const luniaTitle = root.getAttribute("data-lunia-title") || "Lunia";
  const dotiaImage = root.getAttribute("data-dotia-image") || "";
  const luniaImage = root.getAttribute("data-lunia-image") || "";
  const supportEmail = root.getAttribute("data-support-email") || "bonjour@lumixia.fr";

  const form = root.querySelector("[data-tracking-form]");
  const input = root.querySelector("[data-tracking-input]");
  const submitButton = root.querySelector("[data-tracking-submit]");
  const resultNode = root.querySelector("[data-tracking-result]");
  const configNode = document.querySelector("[data-tracking-config]");
  const containerNode = root.querySelector(".tracking-container");
  const orderPanelNode = root.querySelector("[data-order-panel]");
  const orderSummaryNode = root.querySelector("[data-order-summary-content]");

  function setOrderPanelVisible(visible) {
    if (!orderPanelNode) return;
    orderPanelNode.hidden = !visible;
    orderPanelNode.style.display = visible ? "" : "none";
    if (containerNode) {
      containerNode.classList.toggle("tracking-container--with-side", !!visible);
    }
  }

  function isEmailQuery(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function isOrderQuery(value) {
    return /^#?\d{4,}$/.test(value);
  }

  function isTrackingQuery(value) {
    return /^6A\d{11}$/i.test(value);
  }

  function isSupportedQueryFormat(value) {
    return isEmailQuery(value) || isOrderQuery(value) || isTrackingQuery(value);
  }

  function safeNumber(value, fallback) {
    const num = Number(value);
    return Number.isFinite(num) && num > 0 ? num : fallback;
  }

  function readConfig() {
    if (!configNode) {
      return {
        steps: DEFAULT_STEPS,
        stepDurationsDays: [2, 4, 2, 2, 2],
        deliveryStartOffsetDays: 10,
        deliveryEndOffsetDays: 14,
      };
    }

    try {
      const parsed = JSON.parse(configNode.textContent || "{}");
      const steps = Array.isArray(parsed.steps) && parsed.steps.length === 6 ? parsed.steps : DEFAULT_STEPS;
      const stepDurationsDays = Array.isArray(parsed.stepDurationsDays)
        ? parsed.stepDurationsDays.slice(0, 5).map(function (d, index) {
            return safeNumber(d, [2, 4, 2, 2, 2][index] || 2);
          })
        : [2, 4, 2, 2, 2];

      return {
        steps: steps,
        stepDurationsDays: stepDurationsDays,
        deliveryStartOffsetDays: safeNumber(parsed.deliveryStartOffsetDays, 10),
        deliveryEndOffsetDays: safeNumber(parsed.deliveryEndOffsetDays, 14),
      };
    } catch (error) {
      return {
        steps: DEFAULT_STEPS,
        stepDurationsDays: [2, 4, 2, 2, 2],
        deliveryStartOffsetDays: 10,
        deliveryEndOffsetDays: 14,
      };
    }
  }

  const trackingConfig = readConfig();
  const STEPS = trackingConfig.steps;

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getQueryFromUrl() {
    const url = new URL(window.location.href);
    return (
      url.searchParams.get("q") ||
      url.searchParams.get("tracking") ||
      url.searchParams.get("code") ||
      ""
    ).trim();
  }

  function setLoading() {
    resultNode.innerHTML = '<div class="tracking-loading">Recherche du suivi en cours...</div>';
    setOrderPanelVisible(false);
  }

  function setError(message) {
    resultNode.innerHTML =
      '<div class="tracking-error">' +
      escapeHtml(message || "Une erreur est survenue.") +
      "</div>";
    setOrderPanelVisible(false);
  }

  function renderNotFound(payload, query) {
    const email = payload.supportEmail || supportEmail;
    const validFormat = isSupportedQueryFormat(query || "");
    const title = validFormat
      ? "Aucune commande n'a ete trouvee avec cette information."
      : "Le format saisi ne semble pas valide.";
    const subtitle = validFormat
      ? "Verifiez votre code puis reessayez, ou utilisez votre email / numero de commande."
      : "Utilisez un numero de suivi Colissimo (ex: 6A12345678901), un numero de commande (#12345) ou un email.";
    var productCards = [
      { title: dotiaTitle, url: dotiaUrl, image: dotiaImage },
      { title: luniaTitle, url: luniaUrl, image: luniaImage },
    ]
      .filter(function (item) { return item.url; })
      .map(function (item) {
        var imageHtml = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="180" height="180">'
          : "";
        return (
          '<a class="tracking-fallback-card" href="' + escapeHtml(item.url) + '">' +
          imageHtml +
          '<span class="tracking-fallback-card__title">' + escapeHtml(item.title) + "</span>" +
          '<span class="tracking-fallback-card__cta">Commander</span>' +
          "</a>"
        );
      })
      .join("");

    resultNode.innerHTML =
      '<div class="tracking-empty">' +
      "<p>" + escapeHtml(title) + "</p>" +
      "<p>" + escapeHtml(subtitle) + "</p>" +
      (productCards ? '<div class="tracking-fallback-grid">' + productCards + "</div>" : "") +
      '<div class="tracking-empty__actions"><a href="mailto:' +
      escapeHtml(email) +
      '">Contacter le SAV</a></div>' +
      "</div>";
    setOrderPanelVisible(false);
  }

  function renderSteps(payload) {
    return STEPS.map(function (stepItem) {
      const state =
        stepItem.step < payload.step
          ? "is-complete"
          : stepItem.step === payload.step
            ? "is-active"
            : "is-upcoming";

      const dynamicDescription = stepItem.description
        .replace("[DATE_START]", payload.deliveryStart || "")
        .replace("[DATE_END]", payload.deliveryEnd || "");

      let subprogressHtml = "";
      if (stepItem.step === payload.step && payload.step < 6) {
        subprogressHtml =
          '<div class="tracking-step__subprogress">' +
          '<div class="tracking-step__subprogress-bar">' +
          '<div class="tracking-step__subprogress-fill" style="width:' +
          Math.round((payload.stepProgress || 0) * 100) +
          '%"></div>' +
          "</div>" +
          "</div>";
      }

      return (
        '<li class="tracking-step ' +
        state +
        '">' +
        '<h3 class="tracking-step__title">' +
        escapeHtml(stepItem.title) +
        "</h3>" +
        '<p class="tracking-step__description">' +
        escapeHtml(dynamicDescription) +
        "</p>" +
        subprogressHtml +
        "</li>"
      );
    }).join("");
  }

  function renderCollapsedInternalSteps() {
    var collapsedItems = STEPS.slice(0, 5)
      .map(function (stepItem) {
        return (
          '<li class="tracking-step is-complete">' +
          '<h3 class="tracking-step__title">' +
          escapeHtml(stepItem.title) +
          "</h3>" +
          '<p class="tracking-step__description">' +
          escapeHtml(stepItem.description) +
          "</p>" +
          "</li>"
        );
      })
      .join("");

    return (
      '<details class="tracking-collapsed-steps">' +
      '<summary>Etapes internes terminees</summary>' +
      '<ol class="tracking-steps tracking-steps--compact">' +
      collapsedItems +
      "</ol>" +
      "</details>"
    );
  }

  function renderColissimoTimeline(payload) {
    var events = Array.isArray(payload.colissimoEvents) ? payload.colissimoEvents : [];
    var eventsHtml = events
      .map(function (event, index) {
        var stateClass = index === 0 ? "is-active" : "is-complete";
        return (
          '<li class="tracking-colissimo-event ' +
          stateClass +
          '">' +
          '<p class="tracking-colissimo-event__label">' +
          escapeHtml(event.label || "Mise a jour Colissimo") +
          "</p>" +
          "</li>"
        );
      })
      .join("");

    if (!eventsHtml) {
      eventsHtml =
        '<li class="tracking-colissimo-event is-active">' +
        '<p class="tracking-colissimo-event__label">Colissimo a pris en charge votre colis. Le suivi est en cours de mise a jour.</p>' +
        "</li>";
    }

    var statusTitle = payload.colissimoDelivered
      ? "Votre commande a ete livree par Colissimo."
      : "Votre commande est actuellement suivie par Colissimo.";
    var statusSubtitle = payload.colissimoLastEventLabel
      ? payload.colissimoLastEventLabel
      : payload.colissimoDelivered
        ? "Livraison confirmee par Colissimo."
        : "Votre colis est en cours d'acheminement sur les plateformes Colissimo.";

    return (
      '<div class="tracking-colissimo-card">' +
      '<p class="tracking-colissimo-card__title">' +
      escapeHtml(statusTitle) +
      "</p>" +
      '<p class="tracking-colissimo-card__subtitle">' +
      escapeHtml(statusSubtitle) +
      "</p>" +
      '<ol class="tracking-colissimo-events">' +
      eventsHtml +
      "</ol>" +
      "</div>"
    );
  }

  function formatDateFr(date) {
    return new Intl.DateTimeFormat("fr-FR", {
      day: "numeric",
      month: "long",
      timeZone: "UTC",
    }).format(date);
  }

  function applyClientProgress(payload) {
    if (!payload || !payload.fulfilledAt) return payload;

    const fulfilledAtTs = new Date(payload.fulfilledAt).getTime();
    if (!Number.isFinite(fulfilledAtTs)) return payload;

    const nowTs = Date.now();
    const elapsedHours = Math.max((nowTs - fulfilledAtTs) / (1000 * 60 * 60), 0);
    const durationsHours = trackingConfig.stepDurationsDays.map(function (days) {
      return safeNumber(days, 2) * 24;
    });
    const totalHours = durationsHours.reduce(function (sum, value) {
      return sum + value;
    }, 0);

    const deliveryStartDate = new Date(fulfilledAtTs);
    deliveryStartDate.setUTCDate(
      deliveryStartDate.getUTCDate() + trackingConfig.deliveryStartOffsetDays
    );
    const deliveryEndDate = new Date(fulfilledAtTs);
    deliveryEndDate.setUTCDate(
      deliveryEndDate.getUTCDate() + trackingConfig.deliveryEndOffsetDays
    );

    let step = 5;
    let stepProgress = 1;
    let consumed = 0;
    for (var i = 0; i < durationsHours.length; i += 1) {
      var duration = durationsHours[i];
      if (elapsedHours < consumed + duration) {
        step = i + 1;
        stepProgress = Math.max(Math.min((elapsedHours - consumed) / duration, 1), 0);
        break;
      }
      consumed += duration;
    }

    if (payload.showColissimo) {
      step = 6;
      stepProgress = 1;
    }

    var overallProgressPct = payload.showColissimo
      ? 100
      : Math.round(((step - 1 + stepProgress) / 6) * 100);

    return Object.assign({}, payload, {
      step: step,
      stepProgress: stepProgress,
      overallProgressPct: overallProgressPct,
      totalSteps: 6,
      daysSinceFulfillment: Math.floor(elapsedHours / 24),
      deliveryStart: formatDateFr(deliveryStartDate),
      deliveryEnd: formatDateFr(deliveryEndDate),
    });
  }

  function renderTracking(payload) {
    var fallbackDelivered =
      payload.showColissimo && !payload.colissimoDelivered && payload.colissimoStatus === "unknown";
    var isDeliveredDisplay = payload.colissimoDelivered || fallbackDelivered;

    const waitingBanner = payload.waitingBannerVisible
      ? '<div class="tracking-banner"><strong>Pourquoi le suivi Colissimo indique "en attente de reception" ?</strong><br>Nous passons par un premier transporteur qui remet ensuite votre commande au service Colissimo pour la livraison a domicile. Le suivi sur laposte.fr s\'activera automatiquement des que Colissimo aura pris en charge votre colis.</div>'
      : "";

    const colissimoButton = payload.showColissimo
      ? '<a class="tracking-colissimo-link" target="_blank" rel="noopener" href="' +
        escapeHtml(payload.colissimoUrl || "#") +
        '">Suivre sur Colissimo</a>'
      : "";

    var summaryText = isDeliveredDisplay
      ? "Votre commande n" +
        escapeHtml(payload.orderName || "") +
        " a ete livree par Colissimo."
      : "Votre commande n" +
        escapeHtml(payload.orderName || "") +
        " est actuellement en cours d'acheminement. Livraison prevue entre le " +
        escapeHtml(payload.deliveryStart || "") +
        " et le " +
        escapeHtml(payload.deliveryEnd || "") +
        ".";

    var colissimoPayload = Object.assign({}, payload, {
      colissimoDelivered: isDeliveredDisplay,
      colissimoLastEventLabel: isDeliveredDisplay && !payload.colissimoLastEventLabel
        ? "Colis livre."
        : payload.colissimoLastEventLabel,
    });

    var timelineHtml = payload.showColissimo
      ? renderCollapsedInternalSteps() + renderColissimoTimeline(colissimoPayload)
      : '<ol class="tracking-steps">' + renderSteps(payload) + "</ol>";

    resultNode.innerHTML =
      '<div class="tracking-card">' +
      '<p class="tracking-card__summary">' +
      summaryText +
      "</p>" +
      '<div class="tracking-progress">' +
      '<div class="tracking-progress__meta"><span>Progression globale</span><span>' +
      escapeHtml(String(payload.overallProgressPct || 0)) +
      "%</span></div>" +
      '<div class="tracking-progress__bar"><div class="tracking-progress__fill" style="width:' +
      escapeHtml(String(payload.overallProgressPct || 0)) +
      '%"></div></div>' +
      "</div>" +
      "</div>" +
      timelineHtml +
      waitingBanner +
      colissimoButton;

    if (orderPanelNode && orderSummaryNode && payload.trackingNumber) {
      var orderItemsHtml = "";
      if (Array.isArray(payload.orderItems) && payload.orderItems.length > 0) {
        orderItemsHtml =
          '<div class="tracking-order-items">' +
          '<p class="tracking-order-items__title"><strong>Produits commandes</strong></p>' +
          '<ul class="tracking-order-items__list">' +
          payload.orderItems
            .map(function (item) {
              var variantText = item.variantTitle ? " - " + item.variantTitle : "";
              return (
                "<li>" +
                escapeHtml((item.name || "Produit") + variantText) +
                " x" +
                escapeHtml(String(item.quantity || 1)) +
                "</li>"
              );
            })
            .join("") +
          "</ul>" +
          "</div>";
      } else {
        orderItemsHtml =
          '<div class="tracking-order-items">' +
          "<p>Detail produits indisponible pour cette commande.</p>" +
          "</div>";
      }

      var currentStateText = isDeliveredDisplay
        ? "Livree par Colissimo"
        : payload.showColissimo
          ? "Prise en charge Colissimo"
          : "Etape " + escapeHtml(String(payload.step || 1)) + "/6";

      orderSummaryNode.innerHTML =
        '<p><strong>Commande:</strong> ' +
        escapeHtml(payload.orderName || "-") +
        "</p>" +
        '<p><strong>Tracking:</strong> ' +
        escapeHtml(payload.trackingNumber || "-") +
        "</p>" +
        '<p><strong>Etat actuel:</strong> ' +
        currentStateText +
        "</p>" +
        '<p><strong>Livraison estimee:</strong> ' +
        escapeHtml(payload.deliveryStart || "-") +
        " - " +
        escapeHtml(payload.deliveryEnd || "-") +
        "</p>" +
        orderItemsHtml;
      setOrderPanelVisible(true);
    } else {
      setOrderPanelVisible(false);
    }
  }

  async function fetchTracking(value) {
    const query = (value || "").trim();
    if (!query) {
      setError("Merci de renseigner un numero de suivi, un numero de commande, ou un email.");
      return;
    }

    if (!isSupportedQueryFormat(query)) {
      renderNotFound({}, query);
      return;
    }

    setLoading();
    submitButton.disabled = true;

    try {
      const url = endpoint + "?q=" + encodeURIComponent(query);
      const response = await fetch(url, { method: "GET", credentials: "same-origin" });
      const rawBody = await response.text();
      let payload = null;
      try {
        payload = rawBody ? JSON.parse(rawBody) : null;
      } catch (parseError) {
        if (response.status === 404 || response.status === 302 || response.status === 301) {
          throw new Error(
            "Le service de suivi n'est pas encore configure. Merci de finaliser Vercel + App Proxy Shopify."
          );
        }
        throw new Error(
          "Le service de suivi a retourne une reponse invalide. Verifie la configuration App Proxy / Vercel."
        );
      }

      if (!payload || typeof payload !== "object") {
        throw new Error(
          "Le service de suivi est indisponible pour le moment. Merci de reessayer dans quelques minutes."
        );
      }

      if (!response.ok) {
        throw new Error(payload.message || "Erreur de recuperation du suivi.");
      }

      if (!payload.found) {
        renderNotFound(payload, query);
        return;
      }

      renderTracking(applyClientProgress(payload));
    } catch (error) {
      setError(error.message || "Une erreur est survenue.");
    } finally {
      submitButton.disabled = false;
    }
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    fetchTracking(input.value);
  });

  const initialQuery = getQueryFromUrl();
  if (initialQuery) {
    input.value = initialQuery;
    fetchTracking(initialQuery);
  }
})();
